// Services
import { getCurrentUserToken } from '../../../auth/authService';

export default (config) => {
    config.headers = config.headers || {};

    if (config.skipAuthHeader) {
        if (typeof config.headers.delete === 'function') {
            config.headers.delete('Authorization');
            config.headers.delete('authorization');
        } else {
            delete config.headers.Authorization;
            delete config.headers.authorization;
        }
        return config;
    }

    const token = getCurrentUserToken();
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
};
